import React, { useEffect, useState, useRef } from "react";
import "./styles.css";

const slides = [
  {
    title: "We Respect Your World and Make it Better,",
    subtitle: "Smarter and Efficient!",
    description:
      "We handle AI model design, API integration, and React-based front-end in one seamless workflow",
    image: "/banner1.png", // ✅ Change per slide
    bgImage: "/bannerSlider1.jpg", // ✅ Banner background
  },
  {
    title: "Lead the Change",
    subtitle: "Don’t Chase It",
    description: "We help you move ahead of disruption, not run behind it.",
    image: "/banner2.png",
    bgImage: "/bannerSlider3.jpg",
  },
  {
    title: "on technology that works for you",
    subtitle: "So that you can count ",
    description: "We make technology your strength, not another struggle.",
    image: "/banner3.png",
    bgImage: "/bannerSlider4.jpg",
  },
];

const HeroBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideIntervalRef = useRef(null);
  const nextSectionRef = useRef(null);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const startAutoSlide = () => {
    stopAutoSlide();
    slideIntervalRef.current = setInterval(() => {
      nextSlide();
    }, 5000);
  };

  const stopAutoSlide = () => {
    if (slideIntervalRef.current) {
      clearInterval(slideIntervalRef.current);
    }
  };

  const handleScrollDown = () => {
    if (nextSectionRef.current) {
      nextSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, []);

  return (
    <>
      <section
        className="banner"
        id="home"
        style={{
          backgroundImage: `url(${slides[currentSlide].bgImage})`, // ✅ Dynamic background
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        onMouseEnter={stopAutoSlide}
        onMouseLeave={startAutoSlide}
      >
        <div className="overlay"></div>
        <div className="carousel">
          {slides.map((slide, index) => (
            <div
              className={`carousel-slide ${
                index === currentSlide ? "active" : ""
              }`}
              key={index}
            >
              <div className="banner-content">
                <div className="text-section">
                  <h2 className="animate-top-bounce">{slide.title}</h2>
                  <h1 className="animate-right-shake">{slide.subtitle}</h1>
                  <p className="animate-bottom-delay">{slide.description}</p>
                  <button
                    className="learn-more-btn animate-bottom-delay"
                    onClick={() => {
                      document.getElementById("services")?.scrollIntoView({
                        behavior: "smooth",
                      });
                    }}
                  >
                    Read More{" "}
                    <span className="material-icons material-symbols-outlined basearrrow">
                      arrow_forward
                    </span>
                  </button>
                </div>
                <div className="image-blob">
                  <img src="banner_dot.png" alt="Team Planning" />
                </div>
              </div>
            </div>
          ))}

          {/* Navigation arrows */}
          <button className="carousel-btn prev" onClick={prevSlide}>
            &#10094;
          </button>
          <button className="carousel-btn next" onClick={nextSlide}>
            &#10095;
          </button>

          {/* Dots */}
          <div className="carousel-dots">
            {slides.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => goToSlide(index)}
              ></span>
            ))}
          </div>
        </div>

        {/* Scroll down */}
        <div
          className="scroll-down"
          onClick={handleScrollDown}
          style={{ cursor: "pointer" }}
        >
          Scroll Down{" "}
          <span className="material-icons material-symbols-outlined arrow_push">
            south
          </span>
        </div>
      </section>

      {/* 👇 Target section */}
      <section ref={nextSectionRef} className="hiddenscroll">
        <div style={{ padding: "0px", backgroundColor: "#f7f7f7" }}>
          <h2>This is the next section after the banner</h2>
          <p>You smoothly scrolled here!</p>
        </div>
      </section>
    </>
  );
};

export default HeroBanner;
